import { Grid, GridProps } from '@tradener/lumen';

import useColorMode from '~/hooks/useColorMode';
import { grey } from '~/theme';

import useStyles from './styles';

const TableVerticalAxis: React.ComponentType<GridProps> = ({ bgColor, ...props }) => {
  const { colorTernary } = useColorMode();
  const { columnWrapper } = useStyles();

  return (
    <Grid
      gridTemplateColumns="138px"
      gridAutoRows="40px"
      bgColor={bgColor ?? colorTernary(grey[800], 'white')}
      className={columnWrapper}
      {...props}
    />
  );
};

export default TableVerticalAxis;
